/**
 * Blogs 小猪宰汁 
 * Date: 2023/3/2
 * filename：en.js
 */
export const h = {
    KeywordTip: 'Part# / Keyword',
    Keyword: 'Please enter Part or material information!',
    brand:'Mfr',
    search_1:'Part No.',
    search_2:'Mfr',
    search_3:'DC',
    search_4:'Package',
    search_5:'Description',
    search_6:'QTY Price',
    search_7:'Stock Quantity',
    search_8:'Operations',
    search_9:'Buy',
    contactEnter:"Please enter",
    enterName:"Please enter your name",
    enterCompany:"Please enter the company",
    enterPhone:"Please enter your phone number",
    enterEmail:"Please enter your email",
    enterContent:"Please enter content",
    subSccessful:"Submission successful",
    home: "HOME",
    aboutus: "ABOUT US",
    linecard: "LINE CARD",
    qualitycontrol: "QUALITY CONTROL",
    applications: "APPLICATIONS",
    contactus: "CONTACT US",

    introduction: "INTRODUCTION",
    aboutabracon: "About Abracon",
    joinus: "JOIN US",
    seedetails: "See details",
    seemore:'See more',
    fl1_1:'Introduction',
    fl1_2:'Join Us',
    fl2_1:'Top 50 Lines',
    fl2_2:'Promotion lines',
    fl3_1:'Laboratory Inspection Equipment',
    fl3_2:'Supplier Classification & Inspection Overview',
    fl3_3:'Outgoing Quality Control (OQC) Process',
    fl3_4:'Warehouse Control and Management',
    fl4_1:'Product Application',
    fl4_2:'Intellectual Property',
    fr1_1:'+86 755 2643-3662',
    fr1_2:'sales@honengelec.com',
    b2l_1:'Shenzhen',
    b2l_2:'Shanghai',
    b2l_3:'Hong Kong',
    b2l_4:'Suzhou',
    b2l_5:'Nanjing',
    b2l_6:'Wuhan',
    b2l_7:'HeBei',
    b2l_20:'Tianjin',
    b2l_8:'Xiamen',
    b2l_9:'Qingdao',
    b2l_11:'Singapore',
    b2l_10:'粤ICP备20003977号',
    b2r_1:'Privacy Policy',
    b2r_2:'Terms and Conditions of Sales',
    b2r_10:'Global Trade Compliance Statement',
    t_1:'Honeng’s intellectual property Statistical table',
    t_2:'Industrial Control',
    t_3:'Medical Electronics',
    b_1:'Automotive Electronics',
    b_3:'Communication',
    usc_1:'Contact Us',
    usc_2:'Name',
    usc_3:'Company',
    usc_4:'Phone',
    usc_5:'Email',
    usc_6:'Question',
    usc_7:'Submit',
    usc_8:'Our Office',
    usc_9:'Address',
    usc_10:'Fax',
    abouts_1:"Company Events",
    abouts_2:"2020 Annual Meeting",
    abouts_3:"2019 Annual Meeting",
    abouts_4:"Outreach activities",
    abouts_5:"2019 Chongqing",
    abouts_6:"2018 Thailand",
    abouts_7:"2017 Yunnan",
    abouts_8:"Our People",
    abouts_9:"Honeng Electronics' senior leadership team drives success through deep expertise and years of experience in the electronic components industry.",
    join_1:'Job Description',
    join_2:'Job Requirements',
    join_3:'Interested candidates, please send your resume to'
  }